import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function createEditNewsValidator() {
  const title: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El título es obligatorio")],
  });
  const description: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("La noticia es obligatoria")],
  });

  watch(
    () => title.value.val,
    () => {
      if ((title.value.val?.length ?? 0) > 0) {
        title.value.enabled = true;
      }
    }
  );
  watch(
    () => description.value.val,
    () => {
      if ((description.value.val?.length ?? 0) > 0) {
        description.value.enabled = true;
      }
    }
  );


  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    title.value = validate(title.value);
    description.value = validate(description.value);


    return !(
      title.value.isSuccess &&
      description.value.isSuccess
    );
  });

  const successFormEdit = computed(() => {
    title.value = validate(title.value);
    description.value = validate(description.value);


    return !(
      title.value.isSuccess &&
      description.value.isSuccess
    );
  });

  function reset(): void {
    title.value.val = "";
    description.value.val = "";
    title.value.enabled = false;
    description.value.enabled = false;
  }

  return {
    title,
    description,
    successForm,
    successFormEdit,
    reset,
  };
}
